import React from 'react'
import Script from 'next/script'

const HotjarId = process.env.NEXT_PUBLIC_HOTJAR_ID

const HotjarScript = () => {
  if (!HotjarId) {
    return null
  }

  if (
    process.env.STORE === 'equitry-dad' ||
    process.env.STORE === 'equitry-subscription'
  ) {
    return (
      <Script
        id="contentsquare-script"
        src="https://t.contentsquare.net/uxa/64a2074b252dd.js"
        strategy="afterInteractive"
      />
    )
  }

  return (
    <Script
      id="hotjar-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:${HotjarId},hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `,
      }}
    />
  )
}

export { HotjarScript }
